<template>
  <div class="more">
    <Nav></Nav>
      <!-- <div class="header">
        <img src="../assets/img/z.png" alt="" @click="$router.push('/')">
      </div> -->
      <div class="news">
        <img src="../assets/img/banners.png" alt="">
      </div>
      <div class="navbar">

        <ul>

          <li v-for="(item,index) in list" :key="index" @click="navbar(item)" :class="{'fec':crrId===item.id}">{{item.name}}</li>
        </ul>
      </div>
      <div class="main">
        <ul>

          <li v-for="(item,index) in mainlist.slice((pageindex - 1) * pagesize, pageindex * pagesize)" :key="index" v-show="crrId===crrId">

          <div class="matli">
              <div class="img" >
              <img v-lazy="item.news_img" alt="">
            </div>
            <div class="text" @click="accumulations(item)"  v-if="item.news_id" >
              <span>{{item.news_name}}  </span>

              <p>{{item.author + '...'}}  </p>
              <div class="texetbar">
                  <div class="times">
                <img src="../assets/img/timest.png" alt="">
                <span>{{item.add_time}}</span>
              </div>
              <div class="look">
                <img src="../assets/img/loosg.png" alt="">
                <p >{{item.show_num}}</p>
              </div>
              </div>
            </div>
          </div>
           <div class="cats" ></div>
          </li>
        </ul>
      </div>
      <div class="page" >

     <el-pagination
      background
      layout="prev, pager, next"

      :total="mainlist.length"

      :page-size="pagesize"
      :current-page="pageindex"
       @size-change="handleSizeChange"
         @current-change="handleCurrentChange"
      >
    </el-pagination>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../components/Footer'
import Nav from '../components/Nav'

// import img1 from '../assets/img/lb.jpg'
// import img2 from '../assets/img/mj.jpg'
// import img3 from '../assets/img/gy.jpg'
// import img4 from '../assets/img/mty.jpg'
// import img5 from '../assets/img/ct.jpg'
import { Peoplenews, accumulation } from '../api/index.js'
export default {
  components: {
    Footer,
    Nav
  },
  data () {
    return {
      shownum: '',
      ss: '',
      pagesize: 5,
      pageindex: 1,
      crrId: 1,
      list: [{ id: 1, name: '最新资讯' }, { id: 2, name: '行业动态' }, { id: 3, name: '其他相关' }],
      mainlist: []
    }
  },
  created () {
    // const peloolist = JSON.parse(this.$route.query.peloobj)
    // console.log(peloolist)
    this.Peoplen()
    // this.accumulations()
  },
  methods: {
    async  accumulations (item) {
      console.log(item)
      // this.ss = item.news_id

      const res = await accumulation({

      }, {
        news_id: item.news_id
      })
      const { data } = res
      console.log(res)
      this.$router.push({ path: `/new/${item.news_id}`, query: { newst: JSON.stringify(item) } })

      this.shownum = data.show_num
      sessionStorage.setItem('shownum', item.news_id)
      console.log(this.shownum)
    },
    async Peoplen (item) {
      const res = await Peoplenews({

      }, {
        c_id: this.crrId

      })
      console.log(res)
      const { data } = res
      console.log(data)
      if (data.code === 0) {
        this.mainlist = data.data

        console.log(this.mainlist)
        // const rse1 = this.mainlist.slice((this.pageindex - 1) * this.pagesize, this.pageindex * this.pagesize)
      }
    },
    handleSizeChange (va) {
      // this.pagesize = va

    },
    handleCurrentChange (va) {
      this.pageindex = va
    },
    navbar (item) {
      this.crrId = item.id
      if (item.id === 1) {
        this.Peoplen()
      } else if (item.id === 2) {
        this.Peoplen()
      } else {
        this.Peoplen()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .more {
      .header {
    position: fixed;
    width: 100%;
    height: 76px;
    top: 0;
    left: 0;
    z-index: 33;
    background-color: #fff;
    img {
      width: 154px;
      height: 74px;
      cursor: pointer;
      margin-left: 20px;
    }
  }
      .news {
        img {
        height: 450px;
        }
      }
      .navbar {
        height: 84px;
        background-color: #EEEEEE;
        .fec {
        color: #357FEC;
        }
        ul {
          display: flex;
        margin-left: 384px;
          li {

font-family: Microsoft YaHei;
font-weight: bold;
// color: #357FEC;
cursor: pointer;
            line-height: 84px;
            &:nth-child(1) {
              margin-right: 39px;
            }
              &:nth-child(2) {
              margin-right: 59px;
            }
          }
        }
      }
      .main {
        margin-left: 360px;
        margin-top: 60px;

        ul {
          position: relative;

          li {

            .matli {
            display: flex;
             .img {
              margin-right: 59px;
             img {
               width: 380px;
              height: 240px;
             }
            }
            .text {
              cursor: pointer;
              span {
              display: block;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #357FEC;
              font-size: 16px;
              margin-bottom: 32px;
              }
              p {
                width: 541px;
                letter-spacing: 1px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 31px;
                font-size: 15px;
                .router-link {
                  color: #357FEC;
                  margin-left: 5px;
                  font-weight: 700;
                }
              }
              .texetbar {
                margin-top: 87px;
                display: flex;
                .times {
                display: flex;
                margin-top: 4px;
                img {
                  width: 21px;
                  height: 21px;

                }
                span {
                  display: block;
                  width: 120px;
                 font-family: Microsoft YaHei;
                 font-weight: 400;
                 color: #666666;
                 margin-left: 10px;
                }
              }
              .look {
                display: flex;
                margin-left: 50px;

                img {
                  width: 28px;
                  height: 18px;
                  margin-top: 5px;
                }
                p {
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
                  margin-left: 10px;
                }
              }
              }
            }
            }

              .cats {

              width: 1000px;
             height: 1px;
             background-color: #E6E6E6;
              margin-top: 20px;
              margin-bottom: 32px;
            }
          }
        }
      }
      .page {
        display: flex;

      margin-left: 960px;
      margin-top: 71px;
      }
    }
</style>
